import api from '../api/axios';

export interface SectionDDetail {
  id: number;
  organization_id: number;
  project_id: number;
  env_social_risk_summary: string | null;
  sd_impacts_summary:      string | null;
  sd_monitoring_plan:      string | null;
  host_party_requirements: string | null;
  assessment_conclusion:   string | null;
  section_d: number;
  edit_by:    number | null;
  created_at: string | null;
  updated_at: string | null;
}

export type SectionDFieldKey =
  | 'env_social_risk_summary'
  | 'sd_impacts_summary'
  | 'sd_monitoring_plan'
  | 'host_party_requirements'
  | 'assessment_conclusion';

export type SectionDUpdate = Partial<Record<SectionDFieldKey, string | null>>;

const BASE_URL = '/api/section-d';

const sectionDService = {
  getSectionDByProject: async (projectId: number): Promise<SectionDDetail | null> => {
    const res = await api.get<SectionDDetail | null>(`${BASE_URL}/by-project/${projectId}`);
    return res.data;
  },

  saveSectionD: async (projectId: number, data: SectionDUpdate): Promise<SectionDDetail> => {
    const res = await api.put<SectionDDetail>(`${BASE_URL}/${projectId}`, data);
    return res.data;
  },

  resetSectionD: async (projectId: number): Promise<void> => {
    await api.post(`${BASE_URL}/${projectId}/reset`);
  },
};

export default sectionDService;
